
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
 


export default new Vuex.Store({
    state:{
        lang:''
    },
    mutations:{
        setLang(state,val){
           state.lang = val 
        }
    },
    actions:{
        langAction(context,val){
            context.commit('setLang',val)
        }
    }
})
 



// export default store